import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      maxWidth: "100vw",
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingBottom: 0,
      paddingTop: theme.spacing(12),
    },
  },
  recommended: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  recommendedContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      gap: 0,
    },
  },
  recommendedToggle: {
    color: theme.palette.primary.main,
    fontSize: 25,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  recommendedCollections: {
    maxWidth: "100%",
    width: "100%",
    margin: "0 auto",
    "&::-webkit-scrollbar": {
      width: 0,
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100vw",
    },
  },
  showCommentsContainer: {
    marginTop: theme.spacing(2),
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
    },
  },
  collapseCommentsButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  commentsContainer: {
    maxWidth: "605px",
    width: "605px",
    margin: "0 auto",
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "100vw",
    },
  },
  commentsButton: {
    color: theme.palette.primary.main,
  },
  expandedContainer: {
    maxHeight: "400px",
    overflowY: "auto",
  },
  collapsedContainer: {
    maxHeight: "0",
    overflowY: "hidden",
  },
}));
